var parent = require('../../actual/object/create');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/full/object/create.js
// module id = 466
// module chunks = 0 1